import { useParams, useNavigate } from "react-router-dom";

// "Hatha Yoga" -> "hatha-yoga" (same style as the dictionary URLs)
export const toSlug = (text = "") =>
  text
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-+|-+$/g, "");

/**
 * Makes a side-menu page URL driven, e.g. /yoga -> main page,
 * /yoga/hatha-yoga -> the "Hatha Yoga" page. Needs a route like
 * <Route path="/yoga/:slug?" ... />.
 *
 * selectedKey is "home" without a slug, the page's _id when the slug
 * matches, and "not-found" otherwise.
 */
export const useSlugMenu = (pages, basePath, getLabel = (p) => p.yogaType) => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const selectedPage = slug
    ? pages.find((p) => toSlug(getLabel(p)) === slug)
    : null;
  const selectedKey = !slug ? "home" : selectedPage ? selectedPage._id : "not-found";

  const goTo = (page) => {
    navigate(page ? `${basePath}/${toSlug(getLabel(page))}` : basePath);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleMenuClick = (e) =>
    goTo(e.key === "home" ? null : pages.find((p) => p._id === e.key));

  return { slug, selectedPage, selectedKey, goTo, handleMenuClick };
};
